export { default } from './CardValue';



// WEBPACK FOOTER //
// ./src/design-system/molecules/CardValue/index.jsx